import { render, staticRenderFns } from "./mineNews.vue?vue&type=template&id=ce29bdea&scoped=true"
import script from "./mineNews.vue?vue&type=script&lang=js"
export * from "./mineNews.vue?vue&type=script&lang=js"
import style0 from "./mineNews.vue?vue&type=style&index=0&id=ce29bdea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce29bdea",
  null
  
)

export default component.exports